import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { db } from "./firebase";
import parse from "html-react-parser";
import Nav from "./components/Nav";
import Footer from "./components/Footer";

const ArticleDetails = () => {
  const { id } = useParams();
  const [article, setArticle] = useState(null);
  const [relatedArticles, setRelatedArticles] = useState([]);

  useEffect(() => {
    const unsubscribe = db
      .collection("articles")
      .doc(id)
      .onSnapshot((doc) => {
        if (doc.exists) {
          const data = { id: doc.id, ...doc.data() };
          setArticle(data);

          document.title = `${data.title} - مؤسسة محمد إبراهيم أبو عدبة للمحاماة`;

          const updateMeta = (name, content, property = false) => {
            let tag = document.querySelector(
              property ? `meta[property='${name}']` : `meta[name='${name}']`
            );
            if (!tag) {
              tag = document.createElement("meta");
              if (property) tag.setAttribute("property", name);
              else tag.setAttribute("name", name);
              document.head.appendChild(tag);
            }
            tag.setAttribute("content", content || "");
          };

          updateMeta("description", data.title);
          updateMeta("og:title", data.title, true);
          updateMeta("og:description", data.title, true);
          updateMeta("og:image", data.imageUrl, true);
          updateMeta("og:type", "article", true);
          updateMeta("twitter:card", "summary_large_image", true);
          updateMeta("twitter:title", data.title, true);
          updateMeta("twitter:description", data.title, true);
          updateMeta("twitter:image", data.imageUrl, true);

          db.collection("articles")
            .where("section", "==", data.section)
            .orderBy("createdAt", "desc")
            .limit(5)
            .get()
            .then((snapshot) => {
              const rel = snapshot.docs
                .map((d) => ({ id: d.id, ...d.data() }))
                .filter((a) => a.id !== data.id);
              setRelatedArticles(rel);
            });
        }
      });

    return () => unsubscribe();
  }, [id]);

  if (!article)
    return (
      <p style={{ textAlign: "center", marginTop: "150px" }}>
        جاري تحميل المقال...
      </p>
    );

  return (
    <>
      <Nav />

      <div
        className="article-page"
        style={{ background: "#f8f9f7", padding: "120px 20px 80px" }}
      >
        <div
          className="container"
          style={{ maxWidth: "1000px", margin: "0 auto" }}
        >
          {/* المقال الأساسي */}
          <div
            className="article-card"
            style={{
              background: "#fff",
              borderRadius: "20px",
              boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
              padding: "40px",
              marginBottom: "60px",
            }}
          >
            <h1
              style={{
                fontSize: "2.2rem",
                textAlign: "center",
                marginBottom: "25px",
                color: "#143414",
                fontWeight: "700",
                lineHeight: "1.6",
              }}
            >
              {article.title}
            </h1>

            {article.imageUrl && (
              <img
                src={article.imageUrl}
                alt={article.title}
                style={{
                  width: "100%",
                  borderRadius: "12px",
                  marginBottom: "25px",
                  maxHeight: "500px",
                  objectFit: "cover",
                }}
              />
            )}

            <div
              className="article-content"
              style={{
                fontSize: "1.1rem",
                color: "#333",
                lineHeight: "2.1",
              }}
            >
              {article.content ? parse(article.content) : null}
            </div>
          </div>

          {/* المقالات الأخرى */}
          <div className="related-articles">
            <h2
              style={{
                fontSize: "1.6rem",
                color: "#143414",
                marginBottom: "30px",
                fontWeight: "700",
              }}
            >
              مقالات أخرى في قسم {article.section}
            </h2>

            <div
              className="related-grid"
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                gap: "24px",
              }}
            >
              {relatedArticles.length > 0 ? (
                relatedArticles.map((a) => (
                  <div
                    key={a.id}
                    className="related-card"
                    style={{
                      background: "#fff",
                      borderRadius: "12px",
                      boxShadow: "0 3px 10px rgba(0,0,0,0.05)",
                      overflow: "hidden",
                      transition: "transform 0.3s ease",
                    }}
                  >
                    <img
                      src={a.imageUrl}
                      alt={a.title}
                      style={{
                        width: "100%",
                        height: "180px",
                        objectFit: "cover",
                      }}
                    />
                    <div style={{ padding: "15px" }}>
                      <h3
                        style={{
                          fontSize: "1rem",
                          color: "#143414",
                          marginBottom: "10px",
                          lineHeight: "1.5",
                          height: "48px",
                          overflow: "hidden",
                        }}
                      >
                        {a.title}
                      </h3>
                      <Link
                        to={`/article/${a.id}`}
                        style={{
                          display: "inline-block",
                          padding: "8px 16px",
                          background: "#9cd47a",
                          color: "#143414",
                          borderRadius: "6px",
                          textDecoration: "none",
                          fontWeight: "600",
                          transition: "background 0.3s",
                        }}
                      >
                        عرض المقالة
                      </Link>
                    </div>
                  </div>
                ))
              ) : (
                <p>لا توجد مقالات أخرى في هذا القسم</p>
              )}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default ArticleDetails;
